"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AuthenticationCardLogo_1 = __importDefault(require("@/Jetstream/AuthenticationCardLogo"));
// @ts-ignore
var inertia_react_1 = require("@inertiajs/inertia-react");
function PrivacyPolicy(_a) {
    var policy = _a.policy;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(inertia_react_1.Head, { title: "Privacy Policy" }),
        react_1.default.createElement("div", { className: "font-sans text-gray-900 antialiased" },
            react_1.default.createElement("div", { className: "pt-4 bg-gray-100" },
                react_1.default.createElement("div", { className: "min-h-screen flex flex-col items-center pt-6 sm:pt-0" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(AuthenticationCardLogo_1.default, null)),
                    react_1.default.createElement("div", { className: "w-full sm:max-w-2xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose", dangerouslySetInnerHTML: { __html: policy } }))))));
}
exports.default = PrivacyPolicy;
